export default __webpack_public_path__ + "static/media/er5.f0e64025.jpg";